import { render } from "./SlotsComponent.vue?vue&type=template&id=84ed19cc"
import script from "./SlotsComponent.vue?vue&type=script&lang=js"
export * from "./SlotsComponent.vue?vue&type=script&lang=js"

import "./SlotsComponent.vue?vue&type=style&index=0&id=84ed19cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__